import '../Styles/ProjectionsStyles.css';
import { Component } from 'preact';
import { index } from 'd3';
var alphaShape = require('alpha-shape')
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Formfield from 'preact-material-components/FormField';
import Switch from 'preact-material-components/Switch';
import {contorno_lateral} from '../assets/data/contorno_lateral.js';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

class LateralProjectionComponent extends Component {

  constructor(props){
    super(props)
    this.state = {
      titleDropDownCategory: ["Category","Category" ], //Titulo categorias
      titleDropDownSubcategory:["Subcategory","Subcategory"], //Titulo subcategorías
      indexCategory:[-1,-1], //Index contorno seleccionado (categoria)
      indexSubcategory:[-1,-1], ///Index contorno seleccionado (subcategoria)
      percentil50:[true,true],//checkbox percentil 50
      percentil90:[true,true], //checkbox percentil 90
      categories:[],//lista de Dropdown.Item de categoria
      subcategories:[[],[]], //lista de Dropdown.Item de subcategoria
      BRContours:[[],[]], //lista de puntos que forman los contornos
      BRContours50:[[],[]], //lista de puntos que forman los contornos
      svg:[],
      switchHighlighted:false, //swicth "Only Highlighted Data"
      selectedItems: null,
      data_detrital:[]
    }
    this.hdlDonwload = this.hdlDonwload.bind(this);
  }

  /**
  * se invoca inmediatamente después de montar un componente
  */
  componentDidMount(){
    // set the dimensions and margins of the graph
    var margin = {top: 20, right: 20, bottom: 35, left: 60},
    width = 200,
    height = 300;

    //Remove content
    d3.select("#left-scatter").selectAll("*").remove()

    // append the svg object to the body of the page
    var svg = d3.select("#left-scatter")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    .append("g")
    .attr("transform","translate(" + margin.left + "," + margin.top + ")");

    var xScale = d3.scaleLinear().domain([0, 1]).range([0, width]),
    yScale = d3.scaleLinear().domain([0, 1]).range([height, 0]);

    // Title
    svg.append('text')
    .attr('x', width/2)
    .attr('y', 0)
    .attr('text-anchor', 'middle')
    .style('font-family', "Inter")
    .style('font-size', 20)
    .text('');

    // X label
    svg.append('text')
    .attr('x', width/2)
    .attr('y', height+30)
    .attr('text-anchor', 'middle')
    .style('font-family', "Inter")
    .text('Fe2+/(Mg + Fe2+)');

    // Y label
    svg.append('text')
    .attr('text-anchor', 'middle')
    .attr('transform', 'translate(-30,' + height/2 + ')rotate(-90)')
    .style('font-family', "Inter")
    .text('Fe3+/(Cr + Al + Fe3+)');

    svg.append("g")
    .attr("transform", "translate(0," + height + ")")
    .call(d3.axisBottom(xScale).ticks(3));

    svg.append("g")
    .call(d3.axisLeft(yScale));

    this.setState({svg:svg});
    this.loadCategories();

  }

  //se invoca antes de renderizar cuando se reciben nuevas propiedades o estados
  componentDidUpdate(prevProps){


    if(!(prevProps.filteredData_projection.length == this.props.filteredData_projection.length)){
      this.updateSelectData(this.props);
    }

    if(!(prevProps.detrital_data.length == this.props.detrital_data.length)){
      this.updateDetritalData(this.props);
    }

    if(prevProps.filteredData_detrital.length!=this.props.filteredData_detrital.length)
    this.updateSelectDetritalData(this.props);

    if(!(prevProps.filteredData_umap.length == this.props.filteredData_umap.length)){
      this.updateNoSelectData(this.props);
    }

    this.updateSelectDetritalData(this.props);
  }

  hdlDonwload(){
    let fig1 = document.getElementById("left-scatter").getElementsByTagName('svg')[0];
    this.saveSVG(fig1, "lateralproj.svg")
  }

  saveSVG(svgEl,name){
    svgEl.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    var svgData = svgEl.outerHTML;
    var preface = '<?xml version="1.0" standalone="no"?>\r\n';
    var svgBlob = new Blob([preface, svgData], {type:"image/svg+xml;charset=utf-8"});
    var svgUrl = URL.createObjectURL(svgBlob);
    var downloadLink = document.createElement("a");
    downloadLink.href = svgUrl;
    downloadLink.download = name;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }


  //Set Checkbox 50 percentil (contorno 1)
  changePercentil50(id){
    let percentiles = this.state.percentil50;
    percentiles[id] = !this.state.percentil50[id];
    this.setState({percentil50: percentiles},()=>this.uploadBRContours(id));
  }

  //Set Checkbox 90 percentil (contorno 1)
  changePercentil90(id){
    let percentiles = this.state.percentil90;
    percentiles[id] = !this.state.percentil90[id];
    this.setState({percentil90: percentiles},()=>this.uploadBRContours(id));
  }

  //De acuerdo a la categoría y subcategoría seleccionada, cargo los contornos que se van a dibujar (contorno 1)
  uploadBRContours(id){
    let cargarContornos = [];
    let cargarContornos50 = [];
    let j = this.state.indexSubcategory[id];
    if(j>-1){
      if (this.state.percentil90[id] && this.state.percentil50[id]) {
        while ((j < contorno_lateral.length) && (contorno_lateral[j][0] == this.state.titleDropDownCategory[id]) && (contorno_lateral[j][1] == this.state.titleDropDownSubcategory[id])) {
          if ((parseInt(contorno_lateral[j][3]) === 90))
            cargarContornos.push(contorno_lateral[j]);
          else {
            cargarContornos50.push(contorno_lateral[j]);
          }
          j++;
        }
      }
      else {
        if (this.state.percentil90[id] && !this.state.percentil50[id]) {
          j = this.state.indexSubcategory[id];
          while ((j < contorno_lateral.length) && (contorno_lateral[j][0] === this.state.titleDropDownCategory[id]) &&
          (contorno_lateral[j][1] === this.state.titleDropDownSubcategory[id])) {
            if ((parseInt(contorno_lateral[j][3]) === 90))
            cargarContornos.push(contorno_lateral[j]);
            j++;
          }
        }
        else {
          if (!this.state.percentil90[id] && this.state.percentil50[id]) {
            j = this.state.indexSubcategory[id];
            while ((j < contorno_lateral.length) && (contorno_lateral[j][0] === this.state.titleDropDownCategory[id]) &&
            (contorno_lateral[j][1] === this.state.titleDropDownSubcategory[id])) {
              if ((parseInt(contorno_lateral[j][3]) === 50))
              cargarContornos50.push(contorno_lateral[j]);
              j++;
            }
          }
        }
      }
    }
    this.loadBRContour(cargarContornos,id);
    this.loadBRContour50(cargarContornos50,id);
  }

  //carga contornos a renderizar (contorno 1)
  //crea el arreglo de puntos de los contornos. Cada elemento del arreglo se corresponde con un contorno a renderizar.
  loadBRContour(contour,id) {
    var contours = this.state.BRContours;
    contours[id] = [];
    this.setState({BRContours: contours}, () => this.loadBRContourAux(contour,id));
  }

  //carga contornos a renderizar (contorno 1)
  //crea el arreglo de puntos de los contornos. Cada elemento del arreglo se corresponde con un contorno a renderizar.
  loadBRContour50(contour50,id) {
    var contours50 = this.state.BRContours50;
    contours50[id] = [];
    this.setState({BRContours50: contours50}, () => this.loadBRContourAux50(contour50,id));
  }

  /*
  * Carga contornos a renderizar (contorno 1)
  */
  loadBRContourAux(contour,id) {
    let contour1 = [];
    let contornos = [];
    let x = 0;
    let y = 0;
    let i = 5;

    if (contour.length > 0) {
      for (let k = 0; k < contour.length; k++) {

        let cantpoints = parseInt((contour[k][4]));
        i = 5;
        contour1 = [];

        for (let j = 0; j < cantpoints; j++) {
          x = parseFloat(contour[k][i]);
          y = parseFloat(contour[k][i + 1]);

          contour1.push([x / 100, y / 100]);
          i = i + 2;
        }
        contornos.push(contour1);
      }
    }
    let contours = this.state.BRContours;
    contours[id] = contornos;
  }

  /*
  * Carga contornos a renderizar (contorno 1)
  */
  loadBRContourAux50(contour,id) {
    let contour1 = [];
    let contornos = [];
    let x = 0;
    let y = 0;
    let i = 5;

    if (contour.length > 0) {
      for (let k = 0; k < contour.length; k++) {

        let cantpoints = parseInt((contour[k][4]));
        i = 5;
        contour1 = [];

        for (let j = 0; j < cantpoints; j++) {
          x = parseFloat(contour[k][i]);
          y = parseFloat(contour[k][i + 1]);

          contour1.push([x / 100, y / 100]);
          i = i + 2;
        }
        contornos.push(contour1);
      }
    }
    let contours = this.state.BRContours50;
    contours[id] = contornos;
    this.setState({BRContours50: contours},()=> this.drawContours());
  }

  drawContours(){

    //dibujo los contornos
    var contorno = [];
    var margin = {top: 20, right: 20, bottom: 35, left: 60},
    width = 200,
    height = 300;

    const curve = d3.line().curve(d3.curveCardinalClosed.tension(0.7));
    d3.select("#left-scatter").selectAll(".contours1").remove()
    d3.select("#left-scatter").selectAll(".contours2").remove()

    if(this.state.BRContours[0].length>0){
      for(let i=0; i< this.state.BRContours[0].length; i++){
        for(let j=0; j< this.state.BRContours[0][i].length; j++){
          contorno.push([(this.state.BRContours[0][i][j][0])* width,height-(this.state.BRContours[0][i][j][1])*height]);
        }
        this.state.svg.append('path')
        .attr('d', curve(contorno))
        .attr("class", "contours1")
        .attr('fill', 'none')
        .attr('stroke', 'rgba(0,0,0,1)')
        .style("stroke-width", 1)
        contorno = [];
      }
    }
    if(this.state.BRContours[1].length>0){
      for(let i=0; i< this.state.BRContours[1].length; i++){
        for(let j=0; j< this.state.BRContours[1][i].length; j++){
          contorno.push([(this.state.BRContours[1][i][j][0])* width,height-(this.state.BRContours[1][i][j][1])*height]);
        }
        this.state.svg.append('path')
        .attr('d', curve(contorno))
        .attr("class", "contours2")
        .attr('fill', 'none')
        .attr('stroke', 'rgba(0,0,0,1)')
        .style("stroke-width", 2)
        contorno = [];
      }
    }

    if(this.state.BRContours50[0].length>0){
      for(let i=0; i< this.state.BRContours50[0].length; i++){
        for(let j=0; j< this.state.BRContours50[0][i].length; j++){
          contorno.push([(this.state.BRContours50[0][i][j][0])* width,height-(this.state.BRContours50[0][i][j][1])*height]);
        }
        this.state.svg.append('path')
        .attr('d', curve(contorno))
        .attr("class", "contours1")
        .attr('fill', 'none')
        .attr('stroke', 'rgba(0,0,0,1)')
        .style("stroke-width", 1)
        .attr("stroke-dasharray", 4 + " " + 4)
        contorno = [];
      }
    }
    if(this.state.BRContours50[1].length>0){
      for(let i=0; i< this.state.BRContours50[1].length; i++){
        for(let j=0; j< this.state.BRContours50[1][i].length; j++){
          contorno.push([(this.state.BRContours50[1][i][j][0])* width,height-(this.state.BRContours50[1][i][j][1])*height]);
        }
        this.state.svg.append('path')
        .attr('d', curve(contorno))
        .attr("class", "contours2")
        .attr('fill', 'none')
        .attr('stroke', 'rgba(0,0,0,1)')
        .style("stroke-width", 2)
        .attr("stroke-dasharray", 4 + " " + 4)
        contorno = [];
      }
    }
  }

  /* Carga los labels de las categorias en el dropdown button*/
  loadCategories() {
    let aux = [];
    let auxCat = [];

    if (contorno_lateral.length > 0) {
      for (let i = 0; i < contorno_lateral.length; i++) {
        if (!(aux.includes(contorno_lateral[i][0]))) {
          aux.push(contorno_lateral[i][0]); //Arreglo auxiliar que lo uso para no repetir los nombres de categorias
          auxCat.push(<Dropdown.Item id={"CAT" + i} key={"CAT" + i} eventKey={"CAT" + i} className="menuitem-home"> {contorno_lateral[i][0]}</Dropdown.Item>);
        }
      }
      this.setState({categories: auxCat});
    }
  }

  /* Selecciona categoria del dropdownbutton y carga los labels de las subcategorias en el dropdown button (contorno 1)*/
  selectCategory(evt,id){
    let category = contorno_lateral[evt.toString().substr(3, 100)][0];
    let titles = this.state.titleDropDownCategory;
    titles[id] = category;
    this.setState({titleDropDownCategory: titles});
    let subtitles = this.state.titleDropDownSubcategory;
    subtitles[id] = "Subcategory";
    this.setState({titleDropDownSubcategory:subtitles});//Al cambiar la category se borra la subcategory anteriormente seleccionada
    let indexSubcategory = this.state.indexSubcategory;
    indexSubcategory[id] = -1;
    this.setState({indexSubcategory:indexSubcategory});
    let contours = this.state.BRContours;
    contours[id] = [];
    this.setState({BRContours:contours});
    let indexCategory = this.state.indexCategory;
    indexCategory[id] = evt.toString().substr(3, 100);
    this.setState({indexCategory:indexCategory });

    let i = evt.toString().substr(3, 100);
    let aux = [];
    let auxSubcat = [];

    while (i < contorno_lateral.length && contorno_lateral[i][0] === category) {
      if (!(aux.includes(contorno_lateral[i][1]))) {
        aux.push(contorno_lateral[i][1]); //Arreglo auxiliar que lo uso para no repetir los nombres de categorys
        auxSubcat.push(<Dropdown.Item key={"SUB" + i} eventKey={"SUB" + i} className="menuitem-home"> {contorno_lateral[i][1]}</Dropdown.Item>);
      }
      i++;
    }
    let subcategories = this.state.subcategories;
    subcategories[id] = auxSubcat;
    this.setState({subcategories: subcategories});
  }

  /*Selecciona la subcategoria en el dropdownbutton y mando a cargar el contorno 1*/
  selectSubcategory(evt,id){
    let subcategory = this.state.titleDropDownSubcategory;
    subcategory[id] = contorno_lateral[evt.toString().substr(3, 100)][1];
    this.setState({titleDropDownSubcategory: subcategory});

    let indexSubcategory = this.state.indexSubcategory;
    indexSubcategory[id] = evt.toString().substr(3, 100)
    this.setState({indexSubcategory:indexSubcategory},()=>  this.uploadBRContours(id));
  }


  /*
  * Dibujo la proyección lateral
  */
  updateNoSelectData(props){
    d3.select("#left-scatter").selectAll(".select_circles").remove()
    var canvas = document.getElementById("overlay-canvas-left-scatter"),
    ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    canvas.width = 280//document.getElementById("container-UMAP").offsetWidth-20;
    canvas.height = 355; //document.getElementById("container-UMAP").offsetHeight-20;


    var margin = {top: 20, right: 20, bottom: 35, left: 60},
    width = 200,
    height = 300;

    var x = d3.scaleLinear()
    .domain([0, 1])
    .range([ 0, width]);

    // Add Y axis
    var y = d3.scaleLinear()
    .domain([0, 1])
    .range([ height, 0]);

    let filteredData_projection = props.filteredData_projection;
    let filteredData_umap = props.filteredData_umap;
    let switchHighlighted = this.state.switchHighlighted;
    let filteredData = filteredData_umap.concat(filteredData_projection);


    var scaleColor = d3.scaleOrdinal()
    .domain(["Alaskan ultramafic","Alkali/Lamprophyres","Basalt","Komatiite","Layered intrusion","Metamorphic","Ophiolite","Xenoliths"])
    .range(["#ED1909","#1E90FF", "#F062CB", "#AA30FF", "#C0FF30", "#FF6347","#30FF40", "#304FFF"])
    //.range(["#ED1909","#F56101", "#1E90FF", "#41A321", "#0087F5", "#02318A","#833D9F", "#F59FD7"])

    var categoryOrder = d3.scaleOrdinal()
    .domain(["Alaskan ultramafic","Alkali/Lamprophyres","Basalt","Komatiite","Layered intrusion","Metamorphic","Ophiolite","Xenoliths"])
    .range([0,1,2,3,4,5,6,7])

    const subcats = [[],
    ["alkali basalt etc","kimberlite","lamproite"],
    ["boninite","flood basalt","hawaii lava lake","island arc","ocean floor","ocean island"],
    ["chromite cores amphibolite AUDK","chromite cores amphibolite ADK","chromite cores greenschist","sulphide"],
    ["chromitite","other","subvolc sills/dykes"],
    ["magnetite rims amphibolite","magnetite rims greenschist"],
    ["chromitite","high p alpine","ocean floor peridotite","chromite"],
    ["basalts","kimberlites","ocean floor"]];

    let data = [];
    filteredData_umap.forEach((item, i) => {
      data.push({i:props.complete_data[filteredData_umap[i]].i,
        x:x(parseFloat(props.complete_data[filteredData[i]]['Fe2'])/
        (parseFloat(props.complete_data[filteredData[i]]['Mg'])+parseFloat(props.complete_data[filteredData[i]]['Fe2']))),
        y:y(parseFloat(props.complete_data[filteredData[i]]['Fe3'])/(parseFloat(props.complete_data[filteredData[i]]['Fe3'])+
        parseFloat(props.complete_data[filteredData[i]]['Cr'])+parseFloat(props.complete_data[filteredData[i]]['Al'])))})
      });

      var svg = d3.select("#left-scatter").select("g")

      var circles = svg.append('g')
      .selectAll("dot")
      .data(filteredData)
      .enter()
      .append("path")
      .attr("class", "select_circles")
      .attr("d", d3.symbol().type( function(d,i){
        return d3.symbolCircle;
      }).size(12))
      .attr("transform", function(d,i) {
        return "translate(" + x(parseFloat(props.complete_data[filteredData[i]]['Fe2'])/
        (parseFloat(props.complete_data[filteredData[i]]['Mg'])+parseFloat(props.complete_data[filteredData[i]]['Fe2']))) + "," +
        y(parseFloat(props.complete_data[filteredData[i]]['Fe3'])/(parseFloat(props.complete_data[filteredData[i]]['Fe3'])+
        parseFloat(props.complete_data[filteredData[i]]['Cr'])+parseFloat(props.complete_data[filteredData[i]]['Al']))) + ")"})
        .style("fill",function(d,i){
          if(subcats[categoryOrder(props.complete_data[filteredData[i]].Category1)].length==0)
          return scaleColor(props.complete_data[filteredData[i]].Category1); //Alkali y Laterite
          else {
            var n = subcats[categoryOrder(props.complete_data[filteredData[i]].Category1)].length; //cantidad de subcategorias
            var color = d3.hsl(scaleColor(props.complete_data[filteredData[i]].Category1));
            var nsub =  subcats[categoryOrder(props.complete_data[filteredData[i]].Category1)].indexOf(props.complete_data[filteredData[i]].Category2)+2; //por lo que se encuentra en la pos 0
            //return d3.hsl(color.h, (((color.s+0.2)/n)*nsub)+(color.s-0.1)  ,(((color.l+0.05)/n)*nsub)+(color.l-0.05));
            return d3.hsl(color.h, ((0.8-0.2)/(n+1))*nsub + 0.2  , ((0.8-0.2)/(n+1))*nsub + 0.2);
          };
        })
        .style("fill-opacity",0.3)
        .style("stroke-width",0.4)
        .style("stroke",function(d,i){
          if(filteredData_umap.includes(d)) return "none";
          if(filteredData_projection.includes(d)) return  "#B90E0A";
          else{
            return "none";

          }
        })
        .style("display",function(d){
          if(switchHighlighted){
            if(!filteredData_projection.includes(d)) return "none";}
          });

          // lasso selection based on the drag events
          let coords = [];
          const lineGenerator = d3.line();

          const pointInPolygon = function (point, vs) {

            var x = point[0],
            y = point[1];

            var inside = false;
            for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
              var xi = vs[i][0],
              yi = vs[i][1];
              var xj = vs[j][0],
              yj = vs[j][1];

              var intersect =
              yi > y != yj > y &&
              x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
              if (intersect) inside = !inside;
            }

            return inside;
          };

          const drawPath = () =>  {

            d3.select("#lasso")
            .style("stroke", "black")
            .style("stroke-width", 1)
            .style("stroke-dasharray", 5)
            .style("fill", "#00000025")
            .attr("d", lineGenerator(coords));
          }

          const dragStart = () =>  {
            coords = [];
            d3.select("#lasso").remove();
            d3.select("#overlay-left")
            .append("path")
            .attr("id", "lasso");
          }

          const dragMove = (event) => {
            let mouseX = d3.event.sourceEvent.offsetX;
            let mouseY = d3.event.sourceEvent.offsetY;
            coords.push([mouseX, mouseY]);
            drawPath();
          }

          const dragEnd = () => {
            let selectedDots = [];

            data.forEach(d => {
              let point = [
                d.x+margin.left,
                d.y+margin.top,
              ];

              if (pointInPolygon(point, coords)) {

                selectedDots.push(d.i);
              }
            });
            this.props.cbk_filteredData_projection(selectedDots);

            selectedDots = [];

            this.state.data_detrital.forEach(d => {
              let point = [
                x(parseFloat(d['Fe2'])/(parseFloat(d['Mg'])+parseFloat(d['Fe2'])))+margin.left,
                y(parseFloat(d['Fe3'])/(parseFloat(d['Fe3'])+parseFloat(d['Cr'])+parseFloat(d['Al'])))+margin.top,
              ];

              if (pointInPolygon(point, coords)) {
                //ctx.beginPath();
                //ctx.arc(point[0], point[1], 5, 0, 2 * Math.PI); // Draw a circle for each data point
                //ctx.fill();
                selectedDots.push(d.i);
              }
            });
            this.props.cbk_filtered_Data_detrital(selectedDots);

          }

          const drag = d3
          .drag()
          .on("start", dragStart)
          .on("drag", dragMove)
          .on("end", dragEnd);

          d3.select("#overlay-left").call(drag);

          this.drawContours();
          this.setState({svg:svg});
        }

        updateSelectData(props){
          let filteredData_umap = props.filteredData_umap;
          let filteredData_projection = props.filteredData_projection;
          let switchHighlighted = this.state.switchHighlighted;

          d3.select("#left-scatter").selectAll(".select_circles")
          .style("stroke",function(d,i){
            //if(filteredData_umap.includes(d)) return "#000";
            if(filteredData_projection.includes(d)) return  "#B90E0A";
            else{
              return "none";
            }
          })
          .style("display",function(d,i){
            if(switchHighlighted){
              if(!filteredData_projection.includes(d)) return "none";}
            })
            .classed("selected_items",function(d,i){
              //if(filteredData_umap.includes(d)) return true;
              if(filteredData_projection.includes(d)) return  true;
              else{
                return false;
              }
            })

            d3.select("#left-scatter").selectAll(".selected_items").raise();
          }

          updateDetritalData(props){
            var margin = {top: 20, right: 20, bottom: 35, left: 60},
            width = 200,
            height = 300;
            const symbol = [d3.symbolCross,d3.symbolSquare,d3.symbolCircle,d3.symbolDiamond2, d3.symbolTriangle, d3.symbolStar, d3.symbolCircle,d3.symbolCross];

            // Add X axis
            var x = d3.scaleLinear()
            .domain([0, 1])
            .range([ 0, width]);

            // Add Y axis
            var y = d3.scaleLinear()
            .domain([0, 1])
            .range([ height, 0]);

            let data = [];
            for(let i = 0; i<props.detrital_data.length;i++){
              data.push({
                i: parseInt(props.detrital_data[i].i),
                id : props.detrital_data[i].id,
                Ref: props.detrital_data[i].Ref,
                'Fe3': parseFloat(props.detrital_data[i]['Fe3']),
                'Cr': parseFloat(props.detrital_data[i]['Cr']),
                'Al': parseFloat(props.detrital_data[i]['Al']),
                'Fe2': parseFloat(props.detrital_data[i]['Fe2']),
                'Mg' : parseFloat(props.detrital_data[i]['Mg']),
              })
            }

            this.setState({data_detrital:data});


            d3.select("#left-scatter").selectAll(".detritos").remove()
            var svg = d3.select("#left-scatter").append("g")
            .attr("transform","translate(" + margin.left + "," + margin.top + ")");
            var filteredData_detrital = props.filteredData_detrital;

            var tooltip = d3.select("#left-scatter")
            .append("div")
            .style("opacity", 0)
            .attr("class", "tooltip")
            .style("background-color", "white")
            .style("border", "solid")
            .style("border-width", "1px")
            .style("border-radius", "5px")
            .style("padding", "10px")

            var circles = svg.append('g')
            .selectAll("circle")
            .data(data)
            .enter()
            .append("path")
            .classed("detritos",true)
            .attr("d", d3.symbol().type( function(d,i){return symbol[d.id];}).size(16))
            .attr("transform", function(d,i) {
              return "translate(" + x(parseFloat(d['Fe2'])/
              (parseFloat(d['Mg'])+parseFloat(d['Fe2']))) + "," +
              y(parseFloat(d['Fe3'])/(parseFloat(d['Fe3'])+
              parseFloat(d['Cr'])+parseFloat(d['Al']))) + ")"})
              .style("fill",function(d,i){
                return "black"; //detritos
              })
              .style("stroke-width",0.8)
              .style("stroke",null)
              //.on("mouseover", (d, i, nodes) => {mouseover(d)} )
              //.on("mouseout", (d, i, nodes) => {mouseout(d)} )
              .on("click", (d, i, nodes) => {
                if(event.ctrlKey) {
                  if(d3.select(nodes[i]).style("stroke")=="#000000"){ //Si el detrito ya esta seleccionado
                    d3.select(nodes[i])
                    .style("fill","rgba(0, 0, 0, 1)")
                    .style("stroke", null)
                  }
                  else {
                    d3.select(nodes[i])
                    .style("fill","rgba(255, 255, 255, 1)")
                    .style("stroke", "#000000")
                  }
                  clkSeleccDetrital(d.i);
                }
              });

              const clkSeleccDetrital=(d)=>{
                this.props.clkSeleccDetrital(d);
              }
            }

            updateSelectDetritalData(props){
              let filteredData_detrital = props.filteredData_detrital;
              let switchHighlighted = this.state.switchHighlighted;

              d3.select("#left-scatter").selectAll(".detritos")
              .style("fill",function(d,i){
                if(filteredData_detrital.includes(d.i)) return  "#FFFFFF";
                else return "#000000";
              })
              .style("stroke",function(d,i){
                if(filteredData_detrital.includes(d.i)) return  "#000000";
                else return null;
              })
              .style("display",function(d){
                if(switchHighlighted){
                  if(!filteredData_detrital.includes(d.i)) return "none";}
                })
                .classed("selected_detrital",function(d,i){
                  if(filteredData_detrital.includes(d.i)) return  true;
                  else{
                    return false;
                  }
                })
                d3.select("#left-scatter").selectAll(".selected_detrital").raise();
              }

              render(){

                return (
                  <div>
                  <canvas id="overlay-canvas-left-scatter" width="280" height="355"></canvas>
                  <svg id="left-scatter"></svg>
                  <svg id="overlay-left" width="280" height="355"></svg>
                  <div style={{marginLeft:"0%"}}>
                  <div class="buttonsContour" width="100%">
                  <text class="textTitle">Barnes & Roeder contour</text>
                  </div>
                  <div class="categoryButton">
                  <DropdownButton id="contour1" title={this.state.titleDropDownCategory[0]} onSelect={(e) => this.selectCategory(e,0)}>
                  {this.state.categories}
                  </DropdownButton>
                  <DropdownButton style={{marginLeft:"20px"}} id="contour1" title={this.state.titleDropDownSubcategory[0]} onSelect={(e)=>this.selectSubcategory(e,0)}>
                  {this.state.subcategories[0]}
                  </DropdownButton>
                  </div>
                  <div class="checkboxButton" width="100%">
                  <FormControlLabel
                  value="end"
                  checked = {this.state.percentil50[0]}
                  control={<Checkbox color="primary" onClick={() => this.changePercentil50(0)} />}
                  label="Percentil 50"
                  labelPlacement="end"
                  />
                  <FormControlLabel
                  value="end"
                  checked = {this.state.percentil90[0]}
                  control={<Checkbox color="primary" onClick={() => this.changePercentil90(0)}/>}
                  label="Percentil 90"
                  labelPlacement="end"
                  />
                  </div>
                  <div class="categoryButton">
                  <DropdownButton id="contour2" title={this.state.titleDropDownCategory[1]} onSelect={(e) => this.selectCategory(e,1)}>
                  {this.state.categories}
                  </DropdownButton>
                  <DropdownButton style={{marginLeft:"20px"}} id="contour2" title={this.state.titleDropDownSubcategory[1]} onSelect={(e)=>this.selectSubcategory(e,1)}>
                  {this.state.subcategories[1]}
                  </DropdownButton>
                  </div>
                  <div class="checkboxButton" width="100%">
                  <FormControlLabel
                  value="end"
                  checked = {this.state.percentil50[1]}
                  control={<Checkbox color="primary" onClick={() => this.changePercentil50(1)} />}
                  label="Percentil 50"
                  labelPlacement="end"
                  />
                  <FormControlLabel
                  value="end"
                  checked = {this.state.percentil90[1]}
                  control={<Checkbox color="primary" onClick={() => this.changePercentil90(1)}/>}
                  label="Percentil 90"
                  labelPlacement="end"
                  />
                  </div>
                  <div class="switchButton" width="100%">
                  <Formfield>
                  <Checkbox
                  id="controlled-checkbox"
                  checked={this.state.switchHighlighted}
                  onChange={e =>{this.setState({switchHighlighted:!this.state.switchHighlighted},()=>{this.updateSelectData(this.props);this.updateSelectDetritalData(this.props)}); }}
                  />
                  <label for="controlled-checkbox">
                  Filter unselected samples
                  </label>
                  </Formfield>
                  </div>
                  </div>
                  </div>
                );
              }
            }
            export default LateralProjectionComponent;
